module.exports = __webpack_public_path__ + "img/signal_cellular_2_bar-red.72388fef.svg";